import http from '../../../../api/http'


/**
 * 수료증 양식 목록 조회
 * @param {*} paramObj 
 * @returns 
 */
function retrieveAllPaging(paramObj) {
    return http.post('/admin/certificate/retrieveAllPaging', {
        pageNumber: paramObj.pageNo,
        size: paramObj.size,
        searchType: paramObj.searchType,
        searchInput: paramObj.searchInput,
    })
}

/**
 * 수료증 양식 상세 조회
 * @param {*} templateId 
 * @returns 
 */
function retrieveCertificateTemplateDetail(templateId) {
    return http.get(`/admin/certificate/retrieve?templateId=${templateId}`);
}   

/**
 * 수료증 양식에 연결된 강의 목록 조회
 * @param {*} templateId 
 * @returns 
 */
function retrieveLectureList(paramObj) {
    return http.post(`/admin/certificate/retrieveAllHistoryPaging`, {
        templateId: paramObj.templateId,
        pageNumber: paramObj.pageNo,
        size: paramObj.size,
    });
}   

/**
 * 수료증 양식 생성
 * @param {*} paramObj 
 * @returns 
 */
function createTemplate(paramObj) { // 인증서 템플릿 생성
    return http.post('/admin/certificate/create', {
        certificateName: paramObj.certificateName, // "string",
        frontFixedText: paramObj.frontFixedText,
        frontImageName: paramObj.frontImageName,
        frontImageSize: paramObj.frontImageSize,
        frontImageDir: paramObj.frontImageDir,
        backImageName: paramObj.backImageName,
        backImageSize: paramObj.backImageSize,
        backImageDir: paramObj.backImageDir,
    })
}

/**
 * 수료증 양식 수정
 * @param {*} paramObj 
 * @returns 
 */
function updateTemplate(paramObj) { // 인증서 템플릿 수정
    return http.post('/admin/certificate/update', {
        templateId: paramObj.templateId, // 0,
        certificateName: paramObj.certificateName, // "string",
        frontFixedText: paramObj.frontFixedText,
        frontImageName: paramObj.frontImageName,
        frontImageSize: paramObj.frontImageSize,
        frontImageDir: paramObj.frontImageDir,
        backImageName: paramObj.backImageName,
        backImageSize: paramObj.backImageSize,
        backImageDir: paramObj.backImageDir,
    })
}

/**
 * 수료증 양식 삭제
 * @param {*} templateId 
 * @returns 
 */
function deleteTemplate(templateId) {
    return http.post('/admin/certificate/delete', {
        templateId
    });
}   

export default {
    retrieveAllPaging,
    retrieveCertificateTemplateDetail,
    retrieveLectureList,
    createTemplate,
    updateTemplate,
    deleteTemplate,
}